import { FsEntryType, RemoteUploadState } from '@lucidlink/sdk';
import { abortableIterable } from '../abortable-iterable';
const isDownloadableFile = (entry) => 'state' in entry &&
    entry.key.type === FsEntryType.FILE &&
    entry.state.remoteUpload === RemoteUploadState.CLEAN;
const toDownloadableFile = (entry, zipPath) => ({
    fsEntryKey: entry.key,
    fsEntrySize: entry.meta.size,
    isExternalFile: entry.state.isExternalFile,
    updateTime: entry.meta.updateTime,
    zipPath,
});
async function* visitFolder(folderKey, path, options) {
    yield { kind: 'folder', path };
    // A hub read can stall indefinitely and cannot be cancelled.
    const children = abortableIterable(options.readDir(folderKey), options.signal);
    for await (const child of children) {
        yield* visitEntry(child, path, options);
    }
}
async function* visitEntry(entry, parentPath, options) {
    options.signal.throwIfAborted();
    const path = parentPath ? `${parentPath}/${entry.name}` : entry.name;
    if (isDownloadableFile(entry)) {
        yield { kind: 'file', file: toDownloadableFile(entry, path) };
        return;
    }
    if (entry.key.type === FsEntryType.DIR) {
        yield* visitFolder(entry.key, path, options);
    }
}
// Multi-root walk behind the legacy `startBatchDownload`; goes with the
// `entry-download` flag. After the romoval of the flag this method should be removed as well
export async function* walkDownloadableFiles(roots, options) {
    for (const root of roots) {
        yield* visitEntry(root, '', options);
    }
}
export async function* walkDownloadableFolder(rootFolder, options) {
    options.signal.throwIfAborted();
    yield* visitFolder(rootFolder.key, rootFolder.name, options);
}
